import './App.css';
import React, {Fragment} from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Main from "./Main/Main";
import Button from "@mui/material/Button";
import {s_char} from "./_signals/s_char";
import defaultChar from "./_helper/defaultChar";
import {IlsUser} from "./_interfaces/IlsUser";
import LoginRegister from "./App/LoginRegister";
import GM from "./App/GM";
import PC from "./App/PC";
import {IChar} from "./_interfaces/IChar";
import apiAddress from "./_sig_api/_apiadress";
import createOptions from "./_helper/createOptions";
import {s_chars} from "./_signals/s_chars";
import {v4} from "uuid";
import {
    s_app_cid,
    s_app_mobile, s_app_mobile_tab,
    s_app_rid,
    s_app_sl,
    s_app_uid,
} from "./_signals/s_app";
import {DisciplinesGet} from "./_api/BEDisciplines";
import {TalentsGet} from "./_api/BETalents";
import {SkillsGet} from "./_api/BESkills";
import {NotesGet} from "./_api/BENotes";
import {LPChangesGet} from "./_api/BELPChanges";
import {logout} from "./_helper/logout";
import {WeaponsGet} from "./_api/BEWeapons";
import {ArmorGet} from "./_api/BEArmor";
import {ModsGet} from "./_api/BEMods";
import {MatricesGet} from "./_api/BEMatrices";
import {MatricespellsGet} from "./_api/BEMatricespells";
import {CoinChangesGet} from "./_api/BECoinChanges";
import {InventarSpellsGet} from "./_api/BEInventarSpells";
import {DiaryGet} from "./_api/BEDiary";
import {GrimoireSpellsGet} from "./_api/BEGrimoireSpells";
import {
    BloodMagicSubscriber,
    DisciplinesSubscriber,
    SpellsSubscriber,
    TalentSkillSubscriber
} from "./_helper/DataBehaves";
import data_talente_skills from "./_data/talent_skill";
import data_spells from "./_data/spells";
import data_disziplinen from "./_data/disziplinen";
import {ThreadsGet, ThreadStepsGet} from "./_api/BEThreads";
import bloodmagic_items from "./_data/bloodmagic_items";
import {BloodMagicItemsGet} from "./_api/BEBloodMagicItems";
import {PresetsGet} from "./_api/BEPresets";
import Grid from "@mui/material/Grid";

interface IProps {
}

interface IState {
    loading: boolean,
    hasUser: boolean,
    useChar: string,
    useRound: string,
}

class App extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            hasUser: false,
            useChar: '',
            useRound: '',
        };
    }

    componentDidMount() {
        const mobile = localStorage.getItem('mobile') ?? '0';
        s_app_mobile.value = mobile === '1'

        if (mobile === '1') {
            s_app_mobile_tab.value = 'char'
        }

        this.loadUser()
    }

    loadUser() {
        const user = localStorage.getItem('user');
        if (user) {
            const rid = localStorage.getItem('round');

            const userData: IlsUser = JSON.parse(user);
            s_app_sl.value = userData.sl
            s_app_uid.value = userData.id
            if (rid) {
                s_app_rid.value = rid
            }
            this.setState({hasUser: true})
        }
    }

    private getData() {
        TalentSkillSubscriber.next(data_talente_skills)
        SpellsSubscriber.next(data_spells)
        DisciplinesSubscriber.next(data_disziplinen)
        BloodMagicSubscriber.next(bloodmagic_items)
    }

    private getSCharsData(cid: string, rid: string) {

        ModsGet(rid)
        ArmorGet(cid)
        CoinChangesGet(cid)
        DiaryGet(cid)
        DisciplinesGet(cid)
        InventarSpellsGet(cid)
        GrimoireSpellsGet(cid)
        LPChangesGet(cid)
        MatricesGet(cid);
        MatricespellsGet(cid);
        NotesGet(cid)
        TalentsGet(cid)
        SkillsGet(cid)
        WeaponsGet(cid)
        ThreadsGet(cid)
        ThreadStepsGet(cid)
        BloodMagicItemsGet(cid)
        PresetsGet(cid)
    }

    /**
     * start round as gm
     * - fetch chars and set in s_chars
     * - set first nsc as current as s_char
     * - or create new nsc, join this round and set as current char
     * @param rid
     */
    startRoundGM(rid: string) {
        localStorage.setItem('round', rid);
        s_app_rid.value = rid;
        const user = localStorage.getItem('user');
        if (user) {
            const userData: IlsUser = JSON.parse(user);
            s_app_uid.value = userData.id
        }

        fetch(apiAddress + "/chars/round/" + rid, createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            if (data.hasOwnProperty('characters')) {
                const chars = data.characters as IChar[];
                let firstNsc = false;
                let new_s_chars = new Map();
                if (chars.length > 0) {
                    chars.forEach(c => {
                        new_s_chars.set(c.id, c)
                        if (c.nsc) {
                            firstNsc = true;
                            s_char.value = c;
                            localStorage.setItem('char', c.id);

                            s_app_cid.value = c.id;

                            this.setState({useChar: c.id, useRound: rid})
                        }
                    })
                }
                s_chars.value = new_s_chars;
                if (!firstNsc) {
                    const char = defaultChar;
                    char.id = v4()
                    char.nsc = true;
                    char.visible = false;
                    s_char.value = char;
                    fetch(apiAddress + "/chars/create", createOptions('POST', {
                        id: char.id,
                        nsc: true,
                        visible: false
                    }))
                        .then((res) => {
                            console.log('newChar GM nsc', res.status)
                            if (res.status === 200) {
                                fetch(apiAddress + "/rounds/join/" + rid + '/' + char.id, createOptions('GET'))
                                    .then((res) => res.json()).then((data) => {
                                    console.log("/rounds/join/" + rid + '/' + char.id, data)
                                })
                                s_chars.value = s_chars.value.set(char.id, char)

                                localStorage.setItem('char', char.id);

                                s_app_cid.value = char.id;

                                this.setState({useChar: char.id, useRound: rid})

                            }
                        });
                }


                this.getSCharsData(s_char.value.id, rid);
                this.getData()
            }
        })
    }

    /**
     * start round as sc
     * - fetch chars and set in s_chars
     * - use given char as current s_char
     * @param rid
     * @param char
     */
    startRoundPC(rid: string, char: IChar | undefined) {
        if (char !== undefined) {

            fetch(apiAddress + "/chars/round/" + rid, createOptions('GET'))
                .then((res) => res.json()).then((data) => {
                let new_s_chars = new Map();

                if (data.hasOwnProperty('characters')) {
                    (data.characters as IChar[]).forEach(c => {
                        new_s_chars.set(c.id, c)
                    })
                }
                s_chars.value = new_s_chars;
            })

            s_char.value = char;
            localStorage.setItem('char', char.id);
            localStorage.setItem('round', rid);

            const user = localStorage.getItem('user');
            if (user) {
                const userData: IlsUser = JSON.parse(user);
                s_app_uid.value = userData.id
            }
            s_app_cid.value = char.id;
            s_app_rid.value = rid;

            this.setState({useChar: char.id, useRound: rid})

            this.getSCharsData(s_char.value.id, rid);
            this.getData()
        }
    }

    render() {
        return (<Fragment>
            <CssBaseline/>
            <Container className="outercontainer" fixed disableGutters={s_app_mobile.value}>
                {s_app_uid.value ?
                    <Fragment>
                        {this.state.useChar !== '' ?
                            <Main></Main>
                            :
                            <Grid container style={{marginTop: 40}} direction={'column'}>
                                {s_app_sl.value ?
                                    <GM startRound={(rid) => this.startRoundGM(rid)}></GM>
                                    :
                                    <PC startRound={(rid, char) => this.startRoundPC(rid, char)}></PC>
                                }
                                <Button onClick={() => logout()}>logout</Button>
                            </Grid>
                        }
                    </Fragment>
                    :
                    <LoginRegister loadUser={() => this.loadUser()}></LoginRegister>
                }
            </Container>
        </Fragment>)
    }
}

export default App;
